import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// import { GSDevTools } from 'gsap/GSDevTools';
// gsap.registerPlugin(GSDevTools);

export default function download() {
  gsap.set('#liane11', {
    drawSVG: 0
  });

  gsap.set('#abw_download_btn_last, a#abw_donate_btn', {
    opacity: 0
  });

  // Desktop
  const mm = gsap.matchMedia();
  mm.add('(min-width: 960px)', () => {
    ScrollTrigger.create({
      trigger: '#abw_section_8',
      pin: '#abw_section_8',
      start: 'top top',
      end: '+=200%',
      scrub: true
      // anticipatePin: 1,
    });

    gsap
      .timeline({
        defaults: {
          ease: 'none',
          opacity: 1
        },
        scrollTrigger: {
          trigger: '#abw_section_8',
          pin: false,
          scrub: true,

          start: 'top 40%',
          end: '+=180%'
          // markers: true,
          // id: 'Section 7'
        }
      })
      .fromTo(
        '#liane11',
        { drawSVG: 0 },
        { drawSVG: '58%', ease: 'none', duration: 1.25 },
        0
      )
      .fromTo('#abw_download_btn_last', { opacity: 0 }, { duration: 0.25 }, 1)
      .to('#liane11', { drawSVG: '100%', ease: 'none', duration: 1 }, 2.5)
      .to('#abw_donate_btn', { duration: 0.25 }, 3.5);
  });

  mm.add('(max-width: 959px)', () => {
    ScrollTrigger.create({
      trigger: '#abw_section_8',
      pin: false, //'#abw_section_8',
      start: 'top top',
      end: '+=100%',
      scrub: true,
      anticipatePin: 1
    });

    gsap
      .timeline({
        defaults: {
          ease: 'none',
          opacity: 1
        },
        scrollTrigger: {
          trigger: '#abw_section_8',
          pin: false,
          scrub: true,

          start: 'top 70%',
          end: 'bottom bottom'
          // markers: true,
          // id: 'Section 8'
        }
      })
      .fromTo(
        '#liane11',
        { drawSVG: 0 },
        { drawSVG: '58%', ease: 'none', duration: 1.25 },
        0
      )
      .to('#abw_download_btn_last', { duration: 0.25 }, 1)
      .to('#liane11', { drawSVG: '100%', ease: 'none', duration: 1 }, 2.5)
      .to('#abw_donate_btn', { duration: 0.25 }, 3.5);
  });
  // GSDevTools.create({ animation: tl });
}
